module.exports = __webpack_public_path__ + "static/media/codigo sms_b-01.f2deb7c3.svg";